/* Login Actions */
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

/* Logout Action */
export const LOGOUT = 'LOGOUT';

/* The server refused the credential of a request: the session is over (see session-ended.js) */
export const SESSION_ENDED = 'SESSION_ENDED';

export const SET_USERNAME = 'SET_USERNAME';
export const SET_PASSWORD = 'SET_PASSWORD';
export const RESET_USERNAME_PASSWORD = 'RESET_USERNAME_PASSWORD';

export const FETCH_USER_PERMISSIONS = 'FETCH_USER_PERMISSIONS';
export const FETCH_USER_PERMISSIONS_SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS';
export const FETCH_USER_PERMISSIONS_FAIL = 'FETCH_USER_PERMISSIONS_FAIL';
